import { Type } from 'class-transformer';
import { KeyValueResultDto } from '../../_models/key-value-result-dto';
import { UserNameDisplayResultDto } from '../../_models/user-name-display-result-dto';
import { AccAllowanceSubCategoryResultDto } from './acc-allowance-sub-category-result-dto';
import { AccProjectRawDto } from './acc-project-raw-dto';
import { AccUsersForAssignmentResultDto } from './acc-users-for-assignment-result-dto';

export class AccEditorResultDto {
    @Type(() => AccProjectRawDto)
    projectData: AccProjectRawDto;

    @Type(() => AccUsersForAssignmentResultDto)
    usersForAssignment: AccUsersForAssignmentResultDto[];

    @Type(() => KeyValueResultDto)
    statusResult: KeyValueResultDto[];

    @Type(() => KeyValueResultDto)
    category: KeyValueResultDto[];

    @Type(() => KeyValueResultDto)
    allowanceCategory: KeyValueResultDto[];

    @Type(() => AccAllowanceSubCategoryResultDto)
    allowanceSubCategory: AccAllowanceSubCategoryResultDto[];

    @Type(() => KeyValueResultDto)
    depositType: KeyValueResultDto[];

    @Type(() => KeyValueResultDto)
    depositStatus: KeyValueResultDto[];

    property: string;
    community: string;
    owner: string;

    @Type(() => UserNameDisplayResultDto)
    lastModifiedBy: UserNameDisplayResultDto;

    @Type(() => Date)
    lastModifiedDate: Date;

    isCurrentOwner: boolean;
    currentCustomerName: string;
    currentCustomerId: string;

    boardApprovalRules: string;
    hasProjectNotes: boolean;
    allowProjectNotesLogs: boolean;

    @Type(() => Date)
    defaultDueDate: Date;

    allowLimitedEditAccess: boolean;
}
